import {
    formatBackendDatePtBr,
    formatIsoDate,
    parseBackendDate
} from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';

export const platformOptions = [
    { value: 'ambos', label: 'Ambos' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'web', label: 'Web' }
];

export const fetchAcessosMes = async (mes) => {
    const response = await fetchFlask('getAcessosMes', JSON.stringify({ mes }));
    return response.acessos;
};

export const isMobileAccess = (value) => value === true || value === 1 || value === '1' || value === 'True' || value === 'true';

export const getAccessPlatform = (access) => isMobileAccess(access.mobile) ? 'mobile' : 'web';

export const getPlatformLabel = (access) => isMobileAccess(access.mobile) ? 'Mobile' : 'Web';

export const filterAccessesByPlatform = (accesses, platform) => {
    if (platform === 'ambos') return accesses;
    return accesses.filter((access) => getAccessPlatform(access) === platform);
};

export const buildClientAccessRows = (accesses) => {
    const clientMap = new Map();

    accesses.forEach((access) => {
        const clientId = access.cliente_id;
        const currentClient = clientMap.get(clientId) || {
            id: clientId,
            clienteId: clientId,
            cliente: access.cliente,
            acessos: 0,
            acessosMobile: 0,
            acessosWeb: 0,
            ultimoAcesso: access.data_acesso
        };
        const currentAccessDate = parseBackendDate(access.data_acesso);
        const lastAccessDate = parseBackendDate(currentClient.ultimoAcesso);

        currentClient.acessos += 1;
        if (isMobileAccess(access.mobile)) {
            currentClient.acessosMobile += 1;
        } else {
            currentClient.acessosWeb += 1;
        }

        if (currentAccessDate.getTime() > lastAccessDate.getTime()) {
            currentClient.ultimoAcesso = access.data_acesso;
        }

        clientMap.set(clientId, currentClient);
    });

    return Array.from(clientMap.values());
};

export const buildAccessSummary = (accesses) => {
    const clientAccessCount = new Map();

    accesses.forEach((access) => {
        const currentCount = clientAccessCount.get(access.cliente_id) || 0;
        clientAccessCount.set(access.cliente_id, currentCount + 1);
    });

    const totalClients = clientAccessCount.size;
    const averageAccesses = totalClients ? accesses.length / totalClients : 0;
    const recurringClients = Array.from(clientAccessCount.values())
        .filter((accessCount) => accessCount > 1).length;
    const mobileAccesses = accesses.filter((access) => isMobileAccess(access.mobile)).length;
    const webAccesses = accesses.length - mobileAccesses;

    return {
        totalAccesses: accesses.length,
        totalClients,
        averageAccesses,
        recurringClients,
        mobileAccesses,
        webAccesses
    };
};

export const buildDailyClientAccess = (accesses, selectedMonth) => {
    const daysMap = new Map();
    const year = selectedMonth.getFullYear();
    const month = selectedMonth.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let day = 1; day <= daysInMonth; day++) {
        daysMap.set(formatIsoDate(new Date(year, month, day)), new Set());
    }

    accesses.forEach((access) => {
        const accessDate = parseBackendDate(access.data_acesso);
        const dayKey = formatIsoDate(accessDate);

        if (!daysMap.has(dayKey)) {
            daysMap.set(dayKey, new Set());
        }

        daysMap.get(dayKey).add(access.cliente_id);
    });

    return Array.from(daysMap.entries())
        .sort(([leftDay], [rightDay]) => leftDay.localeCompare(rightDay))
        .map(([day, clientIds]) => ({
            day,
            label: formatBackendDatePtBr(`${day}T00:00:00`),
            clients: clientIds.size
        }));
};
